const o = {
  token: {
    colorPrimary: "#531DAB",
    colorInfo: "#531DAB",
    colorPrimaryBg: "#F9F0FF",
    colorError: "#CF1322",
    colorErrorBg: "#FFF1F0",
    colorWarningText: "#AD4E00",
    colorSuccess: "#237804",
    colorSuccessBg: "#F6FFED",
    fontSizeSM: 13,
    colorInfoBg: "#F0F5FF",
    colorTextBase: "#262626",
    colorTextSecondary: "#4D4D4D",
    colorTextTertiary: "#737373",
    colorTextQuaternary: "#BFBFBF",
    colorBorder: "#D9D9D9",
    colorBorderSecondary: "#F0F0F0",
    colorLink: "#531DAB",
    colorText: "#262626",
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
  },
  inherit: !0,
  components: {
    Layout: {
      headerBg: "#ffffff",
      bodyBg: "#E5E5E5",
      siderBg: "#120338",
      footerBg: "#120338",
      padding: 24,
      headerHeight: 72
    },
    Button: {
      colorText: "#391085",
      defaultShadow: "transparent",
      dangerShadow: "transparent",
      primaryShadow: "transparent"
    },
    Typography: {
      colorLink: "#531DAB",
      colorLinkHover: "#531DAB",
      colorText: "#262626",
      lineHeight: 1.2
    },
    Tag: {
      colorBorder: "#fff0"
    },
    Popover: {
      sizePopupArrow: 0,
      colorText: "#262626"
    },
    Tooltip: {
      colorBgSpotlight: "#262626",
      colorText: "#ffffff"
    },
    Modal: {
      lineHeight: 1.2,
      headerBg: "#fafafa",
      footerBg: "#fafafa"
    },
    Drawer: {
      lineHeight: 1.2
    },
    Grid: {
      lineHeight: 1.2
    },
    Segmented: {
      itemActiveBg: "#EFDBFF",
      itemHoverBg: "#F9F0FF",
      itemSelectedBg: "#EFDBFF",
      itemSelectedColor: "#531DAB"
    }
  }
};
export {
  o as themeConfig
};
//# sourceMappingURL=theme.js.map
